import { defaults } from 'lodash'
import axios from 'axios'
import store from './vuex'
import { setUserToken, setIsLogged } from 'src/app/pages/auth/vuex/mutations-types'
import { addFlash } from 'src/app/components/shareds/flash/vuex/mutations-types'
import errorMessage from 'src/utils/error-message'

var options = { validateStatus: null }
var instance = axios.create(defaults({}, options))

let utils = {
  getErrors: function (response) {
    return errorMessage.buildErrorMessages(response)
  },
  loginRequest (response) {
    return response.config.url.match(process.env.URL_API + 'auth_seller')
  },
  setMessages (response) {
    if (response === undefined && window.localStorage.subdomain) {
      this.setMessage({ message: store._vm.$t('login.alert.invalid_domain'), type: 'ls-alert-danger' })
    } else if (response.status === 401) {
      this.setMessage({ message: store._vm.$t('login.alert.login_error'), type: 'ls-alert-warning' })
    } else if (!this.loginRequest(response)) {
      this.setMessage({ message: store._vm.$t('application.alert.effect_the_login'), type: 'ls-alert-warning' })
    } else {
      this.setMessage({ message: store._vm.$t('application.alert.try_again'), type: 'ls-alert-warning' })
    }
  },
  setMessage (flash) {
    store.commit(addFlash, flash)
    if (!window.location.hash.match('/auth')) window.localStorage.setItem('message', JSON.stringify(flash))
  },
  redirecToLogin: function (response) {
    store.commit(setUserToken, '')
    store.commit(setIsLogged, false)

    this.setMessages(response)
    this.changeLocation()
  },
  changeLocation: function () {
    if (!window.location.hash.match('/auth')) window.location = '/'
  },
  treatErrors: function (response) {
    let errors = utils.getErrors(response)
    utils.buildErrorMessage(errors)
  },
  buildErrorMessage: function (errors) {
    let message = store._vm.$t('application.menu.wrong_thing')
    store.commit(addFlash, { message: message, errors: errors, type: 'ls-alert-danger' })
  },
  responseWithoutSpecialErrors: function (response) {
    if (Object.keys(response.data).length === 1 && response.data['gateway_seller_code']) return undefined
    delete response.data['gateway_seller_code']
    return response
  },
  findingCustomer: function (response) {
    return response.request.responseURL.match(/auth_customer$/)
  }
}

instance.interceptors.request.use(function (request) {
  window.localStorage.removeItem('offline')
  if (request.url.includes('/users/sign_out')) return request

  if (request.data && request.data.requestType === 'customer') {
    request.headers['Authorization'] = store.getters.customerToken
  } else {
    request.headers['Authorization'] = store.getters.userToken
  }
  return request
})

instance.interceptors.response.use(function (response) {
  if (response.config.url.includes('/yapay/balance') || response.config.url.includes('/payment') || response.config.url.includes('/users/sign_out')) return response// Não intercepta a resposta caso seja uma rota referente ao saldo da yapay
  if (response.status === 401) {
    // regra necessária para a tela de checkout quando for cliente novo.
    if (!utils.findingCustomer(response)) utils.redirecToLogin(response)
  } else if (response.status === 422) {
    response = utils.responseWithoutSpecialErrors(response)
    if (response !== undefined) {
      utils.treatErrors(response)
    } else {
      let message = store._vm.$t('application.menu.wrong_thing')
      store.commit(addFlash, { message: message, type: 'ls-alert-danger' })
    }
  }
  return response
},
function () {
  window.localStorage.setItem('offline', 'true')
  let message = store._vm.$t('application.menu.lose_connection')
  store.commit(addFlash, { message: message, type: 'ls-alert-danger' })
})

export default instance



// WEBPACK FOOTER //
// ./src/http.js